import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsEmailViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map